import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import {
  CardElement,
  injectStripe,
} from 'react-stripe-elements';

class StripeCardFormComponent extends React.Component {
  submit = async () => {
    const { token } = await this.props.stripe.createToken({ name: 'Name' });
    if (token !== undefined) {
      this.props.handleCardSumbit(token);
    }
  }

  cancel = async () => {
    this.props.showHideStripeCardForm();
  }

  render() {
    return (
      <div className="checkout">
        <p>Provide card information below</p>
        <CardElement />
        <div style={{ float: 'right' }}>
          <Button onClick={this.cancel} className={this.props.classes.button}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={this.submit} className={this.props.classes.button}>
            Save Card
          </Button>
        </div>
      </div>
    );
  }
}

StripeCardFormComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  stripe: PropTypes.object.isRequired,
  showHideStripeCardForm: PropTypes.func.isRequired,
  handleCardSumbit: PropTypes.func.isRequired,
};

export default injectStripe(StripeCardFormComponent);
